module.exports = __webpack_public_path__ + "static/media/Dec_2025_4.7c214719.webp";